import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  MANAGE_SUPPORT: {
    path: `${baseRoutes.adminBaseRoutes}/manage-support`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon-chats-text" />
      </span>
    ),
  },
};

export default accessRoute;
